import { APICallV1 } from 'reactApp/api/APICall';

export class UserNewDeviceAPICall extends APICallV1 {
    _method = 'profile/new_device';
    _type = 'post';
    defaultData = this._defaultPayload;
}
